import { fromPromise } from 'xstate';
// import { supabase } from '@ad3d/supabase';
import { PrepareSceneInput, PrepareSceneOutput } from '@ad3d/state-machine';
import { SceneDataSchema } from '@ad3d/schemas';
import { splatLoaderService } from '@ad3d/services';

export const prepareSceneActor = fromPromise<PrepareSceneOutput, PrepareSceneInput>(async ({ input }) => {

  console.log(`[Studio] Preparing scene (MOCK): ${input.sceneId}`);

  // Simulate network delay
  await new Promise((resolve) => setTimeout(resolve, 500));

  // Mock Supabase query to retrieve a JSON column
  // const { data, error } = await supabase
  //   .from('scenes')
  //   .select('data, owner_id')
  //   .eq('id', input.sceneId)
  //   .single();

  const mockDbRow = {
    owner_id: 'mock-owner',
    data: {
      schema: 'canonical.scene@1.0',
      scene_id: 'scene-001',
      active_camera_id: 'camera:turntable',
      units: { length: 'meter', angle: 'radian' },
      coordinate_system: { handedness: 'right', up_axis: 'Z', forward_axis: 'Y' },
      root: {
        nodes: [
          {
            id: 'object:backpack',
            type: 'object',
            asset_ref: { 
                pid: 'PID-12345', 
                url: 'https://pub-e9ceb91fefdb433981074db578013f6b.r2.dev/f9527c6d-0076-4039-98b8-9c1274edded3/beauty.sog' },
            transform: {
              translation: [0, 0, 0],
              rotation: [0, 0, 0, 1],
              scale: [1, 1, 1],
            },
          },
          {
            id: 'splat:scene',
            type: 'splat',
            transform: {
              translation: [0, 0, 0],
              rotation: [0, 0, 0, 1],
              scale: [1, 1, 1],
            },
          },
          {
            id: 'camera:turntable',
            type: 'camera_rig',
            role: 'main',
            transform: {
              translation: [0, 0, 0],
              rotation: [0, 0, 0, 1],
              scale: [1, 1, 1],
            },
            rig: {
              mode: 'orbit',
              target: 'object:backpack',
              radius: 1.8,
              height: 0.2,
              azimuth_range: [0, 6.283185],
              polar_angle: 0.4,
            },
          },
          {
            id: 'hero_plane',
            type: 'camera_plane',
            transform: {
              translation: [0, 0, 0],
              rotation: [0, 0, 0, 1],
              scale: [1, 1, 1],
            },
            world_transform: {
              translation: [0, 0, 0],
              rotation: [0, 0, 0, 1],
              scale: [1, 1, 1],
            },
            dimensions: { width: 1.2, height: 1.8 },
            padding: { top: 0.1, bottom: 0.1, left: 0.05, right: 0.05 },
          },
        ],
      },
    },
  };

  const validatedData = SceneDataSchema.parse(mockDbRow.data);

  // RLS (Row Level Security) in Supabase is the primary security layer.
  // If the query fails (e.g. error.code === 'PGRST116'), it means the user
  // doesn't have access or the record doesn't exist.

  // Once we have the data, we calculate application-level permissions
  // for the UI (e.g., showing/hiding the "Save" button).
  const isOwner = input.userId === mockDbRow.owner_id;
  const isAdmin = input.userRole === 'admin';
  const canEdit = isOwner || isAdmin;

  return {
    id: input.sceneId,
    ownerId: mockDbRow.owner_id,
    data: validatedData,
    permissions: {
      canEdit,
      canSave: canEdit,
    },
  };
});

export const loadSplatActor = fromPromise(async ({ input }: { input: { url: string } }) => {
    if (!input.url) return;
    await splatLoaderService.load(input.url);
});
